import { Badge, Divider, HStack, Switch } from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import Button from 'components/v4/Button';
import { Text } from 'components/v4';

export default function SSOTableToolbar({
    isMicrosoftAdded,
    hasActiveProvider,
    ssoIsEnabled,
    isEnforced,
    onAddProvider,
    onEnforceChange,
    ufProviderBtn,
    ufEnforceSSO,
}) {
    return (
        <HStack spacing={3}>
            <Button
                data-walkthroughid={ufProviderBtn}
                isDisabled={isMicrosoftAdded}
                leftIcon={<AddIcon />}
                onClick={onAddProvider}
                size="sm"
                minW="240px">
                Add Microsoft SSO
            </Button>

            <HStack justifyContent="flex-end">
                <Text
                    fontSize="sm"
                    fontWeight="medium"
                    opacity={!ssoIsEnabled ? 0.5 : 1}>
                    SSO Status
                </Text>
                <Badge
                    colorScheme={ssoIsEnabled ? 'green' : 'gray'}
                    borderRadius="full"
                    px={3}
                    py={1}
                    fontSize="xs"
                    fontWeight="semibold"
                    letterSpacing="wide">
                    SSO {ssoIsEnabled ? 'Enabled' : 'Disabled'}
                </Badge>

                <Divider orientation="vertical" h={5} />

                <Text
                    fontSize="sm"
                    fontWeight="medium"
                    opacity={!hasActiveProvider ? 0.5 : 1}>
                    Enforce SSO
                </Text>
                <Switch
                    data-walkthroughid={ufEnforceSSO}
                    isDisabled={!hasActiveProvider}
                    isChecked={isEnforced}
                    onChange={onEnforceChange}
                    size="md"
                />
            </HStack>
        </HStack>
    );
}
